import { defineMessages } from "react-intl";

const namespace = `infractionDispute`;
const infractionDispute = defineMessages({
  title: {
    id: `${namespace}.title`,
    description: "Page Title",
    defaultMessage: "Ticket dispute form"
  },
  description: {
    id: `${namespace}.description`,
    description: "Page Description",
    defaultMessage: "Fill out the info below to submit your dispute and we'll be in touch."
  },
  firstName: {
    id: `${namespace}.firstName`,
    description: "First Name Field",
    defaultMessage: "First Name"
  },
  lastName: {
    id: `${namespace}.lastName`,
    description: "Last Name Field",
    defaultMessage: "Last Name"
  },
  email: {
    id: `${namespace}.email`,
    description: "Email Field",
    defaultMessage: "Email"
  },
  phoneNumber: {
    id: `${namespace}.phoneNumber`,
    description: "Phone Number Field",
    defaultMessage: "Phone Number"
  },
  ticketNumber: {
    id: `${namespace}.ticketNumber`,
    description: "Ticket Number Field",
    defaultMessage: "Ticket Number"
  },
  licensePlate: {
    id: `${namespace}.licensePlate`,
    description: "License Plate Field",
    defaultMessage: "License Plate"
  },
  disputeReason: {
    id: `${namespace}.disputeReason`,
    description: "Dispute Reason Field",
    defaultMessage: "Dispute Reason"
  },
  disputeReasonParked: {
    id: `${namespace}.disputeReasonParked`,
    description: "Dispute Reason - Parked in Evo spot",
    defaultMessage: "Parked in a dedicated Evo parking spot"
  },
  disputeReasonPaid: {
    id: `${namespace}.disputeReasonPaid`,
    description: "Dispute Reason - Paid for parking",
    defaultMessage: "Paid for parking"
  },
  disputeReasonEmergency: {
    id: `${namespace}.disputeReasonEmergency`,
    description: "Dispute Reason - Emergency/breakdown",
    defaultMessage: "Had an emergency/vehicle breakdown"
  },
  disputeReasonOther: {
    id: `${namespace}.disputeReasonOther`,
    description: "Dispute Reason - Other",
    defaultMessage: "Other"
  },
  otherReasonPlaceholder: {
    id: `${namespace}.otherReasonPlaceholder`,
    description: "Other Reason Placeholder",
    defaultMessage: "Please specify your reason (max 100 characters)"
  },
  additionalInfo: {
    id: `${namespace}.additionalInfo`,
    description: "Additional Info Field",
    defaultMessage: "Any additional info you'd like us to know? (max 1000 characters)"
  },
  fileUploadLabel: {
    id: `${namespace}.fileUploadLabel`,
    description: "File Upload Label",
    defaultMessage: "Attach supporting files here (i.e. ticket, photos)"
  },
  fileUploadConstraints: {
    id: `${namespace}.fileUploadConstraints`,
    description: "File Upload Constraints",
    defaultMessage: "Accepted formats: PDF, JPEG, PNG, HEIC, TXT, DOCX. Max file size: 1 MB per file. Up to 2 files."
  },
  fileUploadTooLarge: {
    id: `${namespace}.fileUploadTooLarge`,
    description: "File Too Large Error",
    defaultMessage: "File is too large. Maximum file size is 1 MB per file."
  },
  fileUploadTooMany: {
    id: `${namespace}.fileUploadTooMany`,
    description: "Too Many Files Error",
    defaultMessage: "Too many files. Maximum 2 files allowed."
  },
  fileUploadInvalidFormat: {
    id: `${namespace}.fileUploadInvalidFormat`,
    description: "Invalid File Format Error",
    defaultMessage: "Invalid file format. Accepted formats: PDF, JPEG, PNG, HEIC, TXT, DOCX."
  },
  requiredFieldLegend: {
    id: `${namespace}.requiredFieldLegend`,
    description: "Required Field Legend",
    defaultMessage: "* Required Field"
  },
  successTitle: {
    id: `${namespace}.successTitle`,
    description: "Success Title",
    defaultMessage: "Thanks!"
  },
  successMessage: {
    id: `${namespace}.successMessage`,
    description: "Success Message",
    defaultMessage: "A dispute has now been opened on your behalf. Please allow 5–7 business days for a response. In the meantime, no need to open another dispute for the same ticket by phone or chat – we'll be in touch soon."
  },
  errorGeneric: {
    id: `${namespace}.errorGeneric`,
    description: "Generic Error Message",
    defaultMessage: "Something went wrong!"
  },
  submit: {
    id: `${namespace}.submit`,
    description: "Submit Button",
    defaultMessage: "Submit"
  },
  chooseFiles: {
    id: `${namespace}.chooseFiles`,
    description: "Choose Files Button",
    defaultMessage: "Choose Files"
  },
  headerAlt: {
    id: `${namespace}.headerAlt`,
    description: "Header Image Alt Text",
    defaultMessage: "Evo car parking"
  },
});

export default infractionDispute;
